export interface PageHeaderProps {
	title: React.ReactNode;
	description?: React.ReactNode;
	/** Buttons that act on the whole page. They wrap under the title on phones. */
	actions?: React.ReactNode;
	className?: string;
}

/** The title block that opens a studio page: display-serif h1, one line of context, page actions. */
export function PageHeader({
	title,
	description,
	actions,
	className,
}: PageHeaderProps) {
	return (
		<header
			className={`flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className ?? ""}`}
		>
			<div className="min-w-0">
				<h1 className="font-display text-[28px] font-medium leading-tight tracking-[-0.02em] text-dashboard-text sm:text-[32px]">
					{title}
				</h1>
				{description ? (
					<p className="mt-2 max-w-[60ch] font-body text-sm text-dashboard-muted">
						{description}
					</p>
				) : null}
			</div>
			{actions ? (
				<div className="flex shrink-0 flex-wrap gap-2">{actions}</div>
			) : null}
		</header>
	);
}
